import { lazy, Suspense } from "react";
import CircularLoader from "../../../customs/loader/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/trainingSchedule/main"));

const TrainingSchedule = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default TrainingSchedule;

